export class DailyWeatherDto {
  date: string;             // 'YYYY-MM-DD'
  weatherCode: number;      // WMO weather interpretation code
  maxTempC: number;
  minTempC: number;
  precipitationMm: number;
  maxWindKph: number;
  isWeekend: boolean;
}
